// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"98":"0e5983a3","138":"818857e0","471":"ea7ed08b","533":"ca77f31d","700":"d0938749"}[chunkId] + ".chunk.js";
};